module.exports = __webpack_public_path__ + "static/media/eye.5559d26a.svg";